import {makeReactContext} from 'lib/makeReactContext';

/**
 * Tells all descendants whether the table they are rendering was initially collapsed.
 * @package
 */
export interface TableCollapserContextInterface {
  isTableInitiallyCollapsed: boolean;
}

export const TableCollapserContext = makeReactContext<TableCollapserContextInterface>(() => {
  throw new Error('TableCollapserContext consumer has no parent provider');
}, 'TableCollapserContext');
